module.exports = __webpack_public_path__ + "media/ta.73651af7.mp3";